import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_EXTERNAL_USERS: (query) => ({ query }),
    API: {
      GET_EXTERNAL_USERS: apiResourceActionCreator('externalUsers')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getExternalUsers?${queryString.stringify(query)}`, authToken, action.admin.api.getExternalUsers)

function* getExternalUsers(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'getExternalUsers',
  action: action,
  sagas: getExternalUsers,
  reducers: {
    request: (state, _) => ({
      ...state,
      isFetchingUser: true,
      copyResult: null,
    }),
    success: (state, action) => {
      const updatedUserData = (!state.externalUserData || action.payload.externalUsers.skip === 0) ?
        action.payload.externalUsers : {
          ...state.externalUserData,
          result: state.externalUserData.result.concat(action.payload.externalUsers.result)
        };
      return ({
        ...state,
        isFetchingUser: false,
        externalUserData: updatedUserData,
      })
    },
    failed: (state, _) => ({
      ...state,
      isFetchingUser: false,
    })
  }
}

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getExternalUsers.js